import React from "react";
import { Link } from "react-router-dom";

export default function CookieBanner() {
    const [shown, setShown] = React.useState(false);
    React.useEffect(() => {
        if (!localStorage.getItem("st_cookies_consent")) setShown(true);
    }, []);
    if (!shown) return null;
    const accept = (lvl) => {
        localStorage.setItem("st_cookies_consent", lvl);
        setShown(false);
    };
    return (
        <div className="fixed bottom-4 left-4 right-4 md:left-8 md:right-auto md:max-w-md z-40 card-soft p-5 shadow-lg" data-testid="cookie-banner">
            <div className="overline mb-2">Cookie-uri</div>
            <h3 className="font-heading text-lg mb-2">Valorizăm confidențialitatea ta</h3>
            <p className="text-sm text-muted-foreground mb-4">
                Folosim cookie-uri pentru o experiență mai bună. Poți accepta toate sau doar cele esențiale.
                Detalii în <Link to="/gdpr" className="text-primary underline">Politica GDPR</Link>.
            </p>
            <div className="flex flex-wrap gap-2">
                <button onClick={() => accept("all")} className="btn-primary !py-2 text-sm" data-testid="cookie-accept-all">Accept toate</button>
                <button onClick={() => accept("essential")} className="btn-outline !py-2 text-sm" data-testid="cookie-essential">Doar esențiale</button>
            </div>
        </div>
    );
}
